export enum EVENT_TYPE {

    CheckIn = '00000017-1000-0000-0000-000000000001',
    CheckOut = '00000017-1000-0000-0000-000000000002',
    ProcedureStart = '00000017-1000-0000-0000-000000000003',
    ProcedureEnd = '00000017-1000-0000-0000-000000000004',
    CallPatient = '00000017-1000-0000-0000-000000000005',
}
